import { render, staticRenderFns } from "./TeachRoomJoiner.vue?vue&type=template&id=e2f9de70&scoped=true&"
import script from "./TeachRoomJoiner.vue?vue&type=script&lang=js&"
export * from "./TeachRoomJoiner.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomJoiner.vue?vue&type=style&index=0&id=e2f9de70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f9de70",
  null
  
)

export default component.exports